import apiClient from '../../../shared/config/axios'
import {
  ControllingAggregates,
  ControllingFilters,
  ControllingPdfRequestBody,
  ControllingRow,
  ControllingXlsxRequestBody,
} from '@myapp/contract'
import { Paginated } from '../../../shared/types/IPaginationResponse'

export interface ControllingListResponse extends Paginated<ControllingRow> {
  aggregates: ControllingAggregates
}

export const controllingApi = {
  search: (params: ControllingFilters & { page: number }) =>
    apiClient.get<ControllingListResponse>('/controlling', { params }),

  generatePdf: (body: ControllingPdfRequestBody) =>
    apiClient.post<Blob>('/controlling/pdf', body, { responseType: 'blob' }),

  generateXlsx: (body: ControllingXlsxRequestBody) =>
    apiClient.post<Blob>('/controlling/xlsx', body, { responseType: 'blob' }),
}
